import { render, staticRenderFns } from "./ToDoInvoiceList.vue?vue&type=template&id=2bc7e9b7"
import script from "./ToDoInvoiceList.vue?vue&type=script&lang=js"
export * from "./ToDoInvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports